import axiosInstance from "../utils/axios"

export const faqService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get('/faq', {
      params,
    })
    return response.data
  },
  findById: async (id) => {
    const response = await axiosInstance.get('/faq/'+id)
    return response.data
  },
  store: async (data) => {
    const response = await axiosInstance.post('/faq', data)
    return response.data
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/faq/${id}`, data);
    return response.data;
  },  
  delete: async (id) => {
    const response = await axiosInstance.delete(`/faq/${id}`)
    return response.data
  },
}
